export const TYPE_COLORS = {
  INTJ: { bg: '#EDE9FE', accent: '#7C3AED', border: '#C4B5FD', label: 'violet' },
  INTP: { bg: '#DBEAFE', accent: '#2563EB', border: '#93C5FD', label: 'blue' },
  ENTJ: { bg: '#FFE4E6', accent: '#E11D48', border: '#FECDD3', label: 'rose' },
  ENTP: { bg: '#FFEDD5', accent: '#EA580C', border: '#FED7AA', label: 'orange' },
  INFJ: { bg: '#DCFCE7', accent: '#16A34A', border: '#86EFAC', label: 'green' },
  INFP: { bg: '#EDE9FE', accent: '#7C3AED', border: '#C4B5FD', label: 'violet' },
  ENFJ: { bg: '#CCFBF1', accent: '#0D9488', border: '#5EEAD4', label: 'teal' },
  ENFP: { bg: '#FFEDD5', accent: '#EA580C', border: '#FED7AA', label: 'orange' },
  ISTJ: { bg: '#DBEAFE', accent: '#2563EB', border: '#93C5FD', label: 'blue' },
  ISFJ: { bg: '#DCFCE7', accent: '#16A34A', border: '#86EFAC', label: 'green' },
  ESTJ: { bg: '#FFE4E6', accent: '#E11D48', border: '#FECDD3', label: 'rose' },
  ESFJ: { bg: '#CCFBF1', accent: '#0D9488', border: '#5EEAD4', label: 'teal' },
  ISTP: { bg: '#DBEAFE', accent: '#2563EB', border: '#93C5FD', label: 'blue' },
  ISFP: { bg: '#CCFBF1', accent: '#0D9488', border: '#5EEAD4', label: 'teal' },
  ESTP: { bg: '#FFE4E6', accent: '#E11D48', border: '#FECDD3', label: 'rose' },
  ESFP: { bg: '#FFEDD5', accent: '#EA580C', border: '#FED7AA', label: 'orange' },
};

export const TYPES = {
  INTJ: {
    code: 'INTJ', name: 'Der Architekt', emoji: '🏛️',
    tagline: 'Visionär · Strategisch · Unaufhaltsam',
    category: 'Analytiker', categoryColor: '#7C3AED',
    description: 'Du denkst in Systemen, wo andere nur Chaos sehen. Als INTJ bist du einer der seltensten Typen – und einer der wirkungsvollsten. Du planst nicht für morgen, du planst für das nächste Jahrzehnt. Deine größte Stärke: Du siehst Muster, bevor sie sich entfalten.',
    strengths: ['Strategisches Denken', 'Selbstdisziplin', 'Unabhängigkeit', 'Entschlossenheit'],
    challenges: ['Emotionale Offenheit', 'Ungeduld mit anderen', 'Perfektionismus'],
    famous: ['Elon Musk', 'Friedrich Nietzsche', 'Arnold Schwarzenegger'],
    percent: '2%', rarity: 'Sehr selten',
  },
  INTP: {
    code: 'INTP', name: 'Der Denker', emoji: '🔬',
    tagline: 'Analytisch · Neugierig · Präzise',
    category: 'Analytiker', categoryColor: '#2563EB',
    description: 'Dein Gehirn schläft nie wirklich. Als INTP bist du der Typ, der um 3 Uhr morgens noch Theorien entwickelt und Systeme hinterfragt. Du suchst nicht nach Antworten – du suchst nach den richtigen Fragen.',
    strengths: ['Logisches Denken', 'Kreativität', 'Objektivität', 'Wissensdurst'],
    challenges: ['Prokrastination', 'Soziale Signale', 'Entscheidungsfindung'],
    famous: ['Albert Einstein', 'Charles Darwin', 'Bill Gates'],
    percent: '3%', rarity: 'Selten',
  },
  ENTJ: {
    code: 'ENTJ', name: 'Der Kommandeur', emoji: '⚡',
    tagline: 'Führungsstark · Direkt · Zielstrebig',
    category: 'Analytiker', categoryColor: '#E11D48',
    description: 'Du siehst eine Aufgabe und weißt sofort, wer sie am besten erledigt – meistens du. ENTJs sind geborene Führungspersönlichkeiten. Du schätzt Effizienz über alles und hast keine Zeit für Ausreden.',
    strengths: ['Führungsqualitäten', 'Effizienz', 'Selbstvertrauen', 'Entschlossenheit'],
    challenges: ['Empathie', 'Geduld', 'Zuhören'],
    famous: ['Steve Jobs', 'Margaret Thatcher', 'Gordon Ramsay'],
    percent: '3%', rarity: 'Selten',
  },
  ENTP: {
    code: 'ENTP', name: 'Der Erfinder', emoji: '💡',
    tagline: 'Innovativ · Provokant · Brillant',
    category: 'Analytiker', categoryColor: '#EA580C',
    description: 'Regeln sind für dich Vorschläge. Als ENTP liebst du es, Ideen zu zerlegen, neu zusammenzusetzen und dabei alle herauszufordern. Du bist der Teufelsbeistand in jedem Meeting – und die Person, die die beste Lösung findet.',
    strengths: ['Innovation', 'Debattieren', 'Anpassungsfähigkeit', 'Charisma'],
    challenges: ['Fokus', 'Routine', 'Projekte abschließen'],
    famous: ['Leonardo da Vinci', 'Benjamin Franklin', 'Barack Obama'],
    percent: '3%', rarity: 'Selten',
  },
  INFJ: {
    code: 'INFJ', name: 'Der Advokat', emoji: '🌿',
    tagline: 'Intuitiv · Tief · Idealistisch',
    category: 'Diplomat', categoryColor: '#16A34A',
    description: 'Du weißt oft, was Menschen fühlen, bevor sie es selbst aussprechen. INFJ ist der seltenste Persönlichkeitstyp überhaupt – du trägst eine stille innere Welt in dir, die tiefer geht als die meisten ahnen.',
    strengths: ['Empathie', 'Intuition', 'Kreativität', 'Zielgerichtetheit'],
    challenges: ['Überempfindlichkeit', 'Perfektionismus', 'Burnout-Risiko'],
    famous: ['Martin Luther King Jr.', 'Nelson Mandela', 'Lady Gaga'],
    percent: '1%', rarity: 'Äußerst selten',
  },
  INFP: {
    code: 'INFP', name: 'Der Mediator', emoji: '🎨',
    tagline: 'Kreativ · Empathisch · Werteorientiert',
    category: 'Diplomat', categoryColor: '#7C3AED',
    description: 'Du lebst nach deinen eigenen inneren Werten – und kompromittierst sie für niemanden. Als INFP bist du ein stiller Träumer mit einer enormen emotionalen Tiefe. Deine Kreativität ist dein Kompass.',
    strengths: ['Empathie', 'Kreativität', 'Authentizität', 'Leidenschaft'],
    challenges: ['Selbstkritik', 'Grenzen setzen', 'Pragmatismus'],
    famous: ['J.R.R. Tolkien', 'Johnny Depp', 'Audrey Hepburn'],
    percent: '4%', rarity: 'Selten',
  },
  ENFJ: {
    code: 'ENFJ', name: 'Der Protagonist', emoji: '🌟',
    tagline: 'Inspirierend · Charismatisch · Fürsorglich',
    category: 'Diplomat', categoryColor: '#0D9488',
    description: 'Menschen folgen dir nicht, weil sie müssen – sondern weil du etwas in ihnen entzündest. ENFJs sind natürliche Mentoren und Motivatoren. Du siehst das Potenzial in jedem Menschen.',
    strengths: ['Kommunikation', 'Empathie', 'Führung', 'Zuverlässigkeit'],
    challenges: ['Überengagement', 'Eigene Bedürfnisse', 'Kritik'],
    famous: ['Barack Obama', 'Oprah Winfrey', 'Goethe'],
    percent: '2%', rarity: 'Selten',
  },
  ENFP: {
    code: 'ENFP', name: 'Der Aktivist', emoji: '🦋',
    tagline: 'Enthusiastisch · Kreativ · Verbindend',
    category: 'Diplomat', categoryColor: '#EA580C',
    description: 'Du siehst überall Möglichkeiten, wo andere Hindernisse sehen. ENFPs bringen Energie in jeden Raum – und eine Fähigkeit, Verbindungen herzustellen, die andere sprachlos macht.',
    strengths: ['Enthusiasmus', 'Kreativität', 'Empathie', 'Kommunikation'],
    challenges: ['Fokus', 'Übercommitment', 'Routine'],
    famous: ['Robin Williams', 'Walt Disney', 'Anne Frank'],
    percent: '7%', rarity: 'Häufig',
  },
  ISTJ: {
    code: 'ISTJ', name: 'Der Inspektor', emoji: '🏗️',
    tagline: 'Zuverlässig · Methodisch · Pflichtbewusst',
    category: 'Wächter', categoryColor: '#2563EB',
    description: 'Du bist der Fels in der Brandung. ISTJs halten die Welt am Laufen – durch Verlässlichkeit, Struktur und ein unerschütterliches Pflichtgefühl. Auf dich kann man sich verlassen.',
    strengths: ['Zuverlässigkeit', 'Gründlichkeit', 'Integrität', 'Praktisch'],
    challenges: ['Flexibilität', 'Neue Ideen', 'Emotionaler Ausdruck'],
    famous: ['Angela Merkel', 'Sigmund Freud', 'Warren Buffett'],
    percent: '13%', rarity: 'Häufig',
  },
  ISFJ: {
    code: 'ISFJ', name: 'Der Beschützer', emoji: '🛡️',
    tagline: 'Fürsorglich · Loyal · Beständig',
    category: 'Wächter', categoryColor: '#16A34A',
    description: 'Du erinnerst dich an den Geburtstag jedes Menschen, den du liebst. ISFJs sind die stillen Helden des Alltags – immer da, immer verlässlich, immer fürsorglich.',
    strengths: ['Fürsorge', 'Geduld', 'Detailgenauigkeit', 'Loyalität'],
    challenges: ['Grenzen setzen', 'Veränderung', 'Eigene Bedürfnisse'],
    famous: ['Mutter Teresa', 'Kate Middleton', 'Halle Berry'],
    percent: '13%', rarity: 'Häufig',
  },
  ESTJ: {
    code: 'ESTJ', name: 'Der Manager', emoji: '📋',
    tagline: 'Organisiert · Direkt · Verantwortungsvoll',
    category: 'Wächter', categoryColor: '#E11D48',
    description: 'Chaos ist dein Feind. Als ESTJ weißt du, wie Dinge funktionieren sollten – und du sorgst dafür, dass sie es tun. Du bist der Typ, der Pläne macht, während andere noch überlegen.',
    strengths: ['Organisation', 'Führung', 'Zuverlässigkeit', 'Direktheit'],
    challenges: ['Flexibilität', 'Emotionen anderer', 'Kompromisse'],
    famous: ['Hillary Clinton', 'Frank Sinatra', 'Sheryl Sandberg'],
    percent: '11%', rarity: 'Häufig',
  },
  ESFJ: {
    code: 'ESFJ', name: 'Der Konsul', emoji: '🤝',
    tagline: 'Warmherzig · Sozial · Fürsorglich',
    category: 'Wächter', categoryColor: '#0D9488',
    description: 'Dein Zuhause ist immer offen, dein Herz noch mehr. ESFJs sind das soziale Bindeglied jeder Gruppe – sie erinnern sich an alles und schaffen Harmonie, wo andere Konflikt sehen.',
    strengths: ['Soziale Kompetenz', 'Fürsorge', 'Verlässlichkeit', 'Loyalität'],
    challenges: ['Kritik', 'Grenzen', 'Eigenständigkeit'],
    famous: ['Taylor Swift', 'Bill Clinton', 'Jennifer Garner'],
    percent: '12%', rarity: 'Häufig',
  },
  ISTP: {
    code: 'ISTP', name: 'Der Virtuose', emoji: '🔧',
    tagline: 'Pragmatisch · Kühl · Handwerklich',
    category: 'Forscher', categoryColor: '#2563EB',
    description: 'Du verstehst, wie Dinge funktionieren – durch Anfassen, Ausprobieren, Zerlegen. ISTPs sind die Meister des praktischen Denkens. Während andere reden, handelst du.',
    strengths: ['Problemlösung', 'Kühlheit unter Druck', 'Praktisches Denken', 'Flexibilität'],
    challenges: ['Langzeit-Commitment', 'Emotionen', 'Struktur'],
    famous: ['Clint Eastwood', 'Bear Grylls', 'Scarlett Johansson'],
    percent: '5%', rarity: 'Selten',
  },
  ISFP: {
    code: 'ISFP', name: 'Der Abenteurer', emoji: '🌸',
    tagline: 'Sensibel · Künstlerisch · Frei',
    category: 'Forscher', categoryColor: '#0D9488',
    description: 'Du lebst im Moment und weißt, wie man ihn wirklich erlebt. ISFPs sehen Schönheit überall – in Menschen, Natur, Klang und Farbe. Du folgst deinem Herzen, auch wenn es keinen Sinn ergibt.',
    strengths: ['Ästhetisches Gespür', 'Empathie', 'Anpassungsfähigkeit', 'Authentizität'],
    challenges: ['Zukunftsplanung', 'Konfrontation', 'Selbstvertrauen'],
    famous: ['Michael Jackson', 'Bob Dylan', 'Frida Kahlo'],
    percent: '8%', rarity: 'Gelegentlich',
  },
  ESTP: {
    code: 'ESTP', name: 'Der Unternehmer', emoji: '🚀',
    tagline: 'Energetisch · Direkt · Risikofreudig',
    category: 'Forscher', categoryColor: '#E11D48',
    description: 'Du denkst nicht nach – du handelst. ESTPs leben im Hier und Jetzt mit einer Energie, die andere mitreißt. Kein Risiko ist zu groß, keine Herausforderung zu schwer.',
    strengths: ['Risikobereitschaft', 'Energie', 'Direktheit', 'Krisenmanagement'],
    challenges: ['Langzeitplanung', 'Sensibilität', 'Regeln'],
    famous: ['Donald Trump', 'Ernest Hemingway', 'Madonna'],
    percent: '4%', rarity: 'Selten',
  },
  ESFP: {
    code: 'ESFP', name: 'Der Entertainer', emoji: '🎭',
    tagline: 'Spontan · Energetisch · Lebensfroh',
    category: 'Forscher', categoryColor: '#EA580C',
    description: 'Das Leben ist eine Bühne – und du liebst es, darauf zu stehen. ESFPs bringen Licht in jeden Raum. Du lebst für den Moment, für Menschen, für Freude.',
    strengths: ['Spontaneität', 'Energie', 'Begeisterungsfähigkeit', 'Menschenkenntnis'],
    challenges: ['Planung', 'Ernsthaftigkeit', 'Langzeitfokus'],
    famous: ['Adele', 'Jamie Oliver', 'Marilyn Monroe'],
    percent: '8%', rarity: 'Gelegentlich',
  },
};

export const QUESTIONS = [
  { id:1,  text:'In sozialen Situationen...', a:'rede ich gerne und bin schnell im Gespräch', b:'höre ich lieber zu und brauche Zeit, mich zu öffnen', dim:'EI' },
  { id:2,  text:'Wenn ich Informationen aufnehme...', a:'verlasse ich mich auf konkrete Fakten und Details', b:'denke ich mehr in Zusammenhängen und Möglichkeiten', dim:'SN' },
  { id:3,  text:'Bei Entscheidungen...', a:'analysiere ich sachlich und logisch', b:'achte ich auf Gefühle und Harmonie', dim:'TF' },
  { id:4,  text:'Im Alltag bevorzuge ich...', a:'feste Pläne und klare Strukturen', b:'Flexibilität und spontane Anpassungen', dim:'JP' },
  { id:5,  text:'Nach einem langen Tag bevorzuge ich...', a:'unter Leute gehen und Energie tanken', b:'allein sein und meine Gedanken sortieren', dim:'EI' },
  { id:6,  text:'Ich vertraue eher...', a:'meiner direkten Erfahrung und dem was ich sehe', b:'meiner Intuition und meinem Bauchgefühl', dim:'SN' },
  { id:7,  text:'Bei einem Konflikt ist mir wichtiger...', a:'die sachlich richtige Lösung zu finden', b:'dass sich alle gut dabei fühlen', dim:'TF' },
  { id:8,  text:'Projekte mag ich lieber...', a:'abschließen und von der Liste streichen', b:'offen lassen, falls sich noch etwas ändert', dim:'JP' },
  { id:9,  text:'Bei Gruppenarbeiten...', a:'übernehme ich gerne die Initiative', b:'arbeite ich lieber im Hintergrund', dim:'EI' },
  { id:10, text:'Ideen interessieren mich mehr wenn sie...', a:'praktisch und direkt anwendbar sind', b:'theoretisch und zukunftsorientiert sind', dim:'SN' },
  { id:11, text:'Ich werde eher respektiert für...', a:'mein logisches Urteilsvermögen', b:'meine Fähigkeit andere zu verstehen', dim:'TF' },
  { id:12, text:'Mein Schreibtisch / Zuhause ist eher...', a:'ordentlich und gut organisiert', b:'kreativ chaotisch und spontan', dim:'JP' },
  { id:13, text:'Ich lade meine Energie auf indem ich...', a:'Zeit mit anderen verbringe', b:'Zeit für mich alleine habe', dim:'EI' },
  { id:14, text:'Mich begeistern mehr...', a:'bewährte Methoden und konkrete Ergebnisse', b:'neue Konzepte und unbekannte Möglichkeiten', dim:'SN' },
  { id:15, text:'Wenn jemand weint...', a:'denke ich zuerst wie ich das Problem lösen kann', b:'fühle ich mit und biete emotionale Unterstützung', dim:'TF' },
  { id:16, text:'Urlaub plane ich...', a:'gerne detailliert und im Voraus', b:'spontan und improvisiert', dim:'JP' },
  { id:17, text:'In Meetings...', a:'spreche ich meine Gedanken direkt aus', b:'denke ich erst nach, bevor ich etwas sage', dim:'EI' },
  { id:18, text:'Beim Lernen neuer Dinge...', a:'brauche ich klare Schritt-für-Schritt Anleitungen', b:'springe ich gerne ins kalte Wasser', dim:'SN' },
  { id:19, text:'Ich finde es wichtiger...', a:'ehrlich zu sein, auch wenn es wehtut', b:'taktvoll zu sein, auch wenn es nicht ganz stimmt', dim:'TF' },
  { id:20, text:'Deadlines empfinde ich als...', a:'hilfreich – sie geben mir Struktur', b:'einengend – Kreativität braucht Zeit', dim:'JP' },
  { id:21, text:'Andere beschreiben mich als...', a:'gesprächig und offen', b:'ruhig und nachdenklich', dim:'EI' },
  { id:22, text:'Im Gespräch erzähle ich lieber...', a:'was wirklich passiert ist, mit Details', b:'was ich dabei gedacht und gefühlt habe', dim:'SN' },
  { id:23, text:'Wenn ich ein Buch lese...', a:'suche ich nach praktischen Erkenntnissen', b:'genieße ich die emotionale Reise', dim:'TF' },
  { id:24, text:'Am liebsten arbeite ich mit...', a:'klarem Auftrag und definierten Zielen', b:'Freiheit, selbst zu entscheiden, wie ich vorgehe', dim:'JP' },
  { id:25, text:'Wenn ich neue Leute treffe...', a:'fühle ich mich schnell wohl', b:'brauche ich etwas Zeit, um warm zu werden', dim:'EI' },
  { id:26, text:'Die Zukunft stelle ich mir lieber vor als...', a:'realistisches Weitermachen mit was funktioniert', b:'etwas völlig Neues das noch keiner kennt', dim:'SN' },
  { id:27, text:'Bei Kritik reagiere ich eher...', a:'sachlich – ich nehme sie als Feedback', b:'persönlich – sie trifft mich emotional', dim:'TF' },
  { id:28, text:'Für mich ist Struktur...', a:'notwendig – ohne sie verliere ich den Überblick', b:'hinderlich – sie schränkt mich ein', dim:'JP' },
];

export function calculateType(answers) {
  const scores = { E:0, I:0, S:0, N:0, T:0, F:0, J:0, P:0 };
  answers.forEach(({ dim, choice }) => {
    const [a, b] = dim.split('');
    if (choice === 'a') scores[a]++; else scores[b]++;
  });
  return (scores.E >= scores.I ? 'E':'I') + (scores.S >= scores.N ? 'S':'N') +
         (scores.T >= scores.F ? 'T':'F') + (scores.J >= scores.P ? 'J':'P');
}
